import { LoadingArea } from '@consigli/facade';
import { type FC } from 'react';

/**
 * The backoffice "Checking authorization" screen, shared by both guards so the
 * two look alike. No i18n in backoffice, so the title is English here.
 *
 * min-h-screen, not the dead `cs-m-auto` this replaced: the `cs-` prefix was
 * dropped from the app in #1308, so that class had generated no CSS and left
 * the block flush at the top of the page.
 */
export const CheckingAuthorization: FC = () => (
  <LoadingArea title="Checking authorization" className="min-h-screen" />
);
